
import { ElasticQueryDownloadInterface, ElasticSortingQuery, StringToStringObjectMapping } from '../../interfaces';

export function getElasticQueryDownloadPayload(
  expectedColumns: string[],
  indexName: string,
  isGDX: boolean,
  sortParams: ElasticSortingQuery[],
  query: object,
  fileName: string,
): ElasticQueryDownloadInterface {
  return (
    {
      data: {
        attributes: {
          task_type: 'ELASTIC_QUERY_RESULTS',
          arguments: {
            expected_columns: expectedColumns,
            index_name: indexName,
            is_gdx: isGDX,
            query,
            sort: sortParams,
            file_name: fileName
          }
        }
      }
    }
  )
}

export function getDownloadQuery(term: StringToStringObjectMapping): object {
  return (
    {
      "bool": {
        "filter": {
          "bool": {
            "must": [
              {
                "term": term
              }
            ]
          }
        }
      }
    }
  );
}
